<template>
  <div>
    <van-pull-refresh :value="refresh_status" @refresh="Refresh">
      <van-list @load="LoadMore" :value="true" :finished="is_end" loading-text=" ">
        <slot></slot>
        <slot name="loading"></slot>
        <!-- <img :src="IconEnd" v-if="is_end && total_pages !== 0" class="end-icon" /> -->
      </van-list>
    </van-pull-refresh>
    <NullData v-if="list.length === 0 && showNull" />
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  export default {
    methods: {
      Refresh () {
        this.$emit('update:page', 1)
        this.$emit('update:refresh_status', true)
        this.$emit('refresh')
      },
      LoadMore () {
        if (this.is_end) {
          this.$emit('update:load_status', false)
          return
        }
        this.$emit('update:page', this.page + 1)
        this.$emit('loadmore')
        this.$emit('update:load_status', true)
      }
    },
    computed: {
      is_end () {
        return this.page === this.total_pages || this.total_pages === 0
      },
      ...SetImage(['IconEnd'])
    },
    watch: {
      load_status (to) {
        console.log(to)
      }
    },
    props: {
      refresh_status: {
        type: Boolean,
        default: false
      },
      load_status: {
        type: Boolean,
        default: false
      },
      page: null,
      total_pages: null,
      list: null,
      showNull: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="less">
  .van-pull-refresh {
    overflow: visible;
  }
  .van-loading__spinner {
    display: none !important;
  }
  .end-icon {
    .w(1.91rem);
    .h(.20rem);
    .m(.43rem auto);
    display: block;
  }
</style>
